import { Component, Input, OnInit } from '@angular/core';
import { closedAppointmentStatuses, Complaint, ComplaintAppointment, ComplaintPosition, DocumentAttachment, PersonsService } from '@icc/b2b/shared';
import { ComplaintService } from '../complaint.service';
import { ConfigService, UserService } from '@icc/shared';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'icc-complaint-appointment',
  templateUrl: './complaint-appointment.component.html',
  styleUrls: ['./complaint-appointment.component.scss']
})
export class ComplaintAppointmentComponent implements OnInit {
    @Input() appointment!: ComplaintAppointment;
    @Input() document!: Complaint;
    @Input() index = 0;
    @Input() attachments: DocumentAttachment[] = [];
    @Input() preview = false;
    @Input() positionsWorkflowsGroups: Map<number, ComplaintPosition[]> = new Map<number, ComplaintPosition[]>();

    complaints: Complaint[] = [];

    assignedCompanyName: string | undefined;

    canEdit = true;

    isServiceman: boolean;

    activeUserCompanyId: number;

    constructor(
        private complaintService: ComplaintService,
        private personsService: PersonsService,
        private configService: ConfigService,
        private permissionsService: NgxPermissionsService,
    ) {
        this.activeUserCompanyId = Number(this.configService?.user?.user?.ActiveCompany);
    }

    async ngOnInit(): Promise<void> {
        await this.determineEditAccess();
        if ((this.appointment.assignedCompanyId === this.document.authorizedRetailer?.companyId) || (this.appointment.assignedCompanyId === this.document.authorizedRetailerCompanyId)) {
            this.assignedCompanyName = this.document.authorizedRetailer?.companyName;
        } else if (this.appointment.assignedCompanyId === this.document.distributor?.companyId) {
            this.assignedCompanyName = this.document.distributor?.companyName;
        } else if (this.appointment.assignedCompanyId === this.document.manufacturer?.companyId) {
            this.assignedCompanyName = this.document.manufacturer?.companyName;
        }
        this.permissionsService
            .hasPermission('complaint-appointment-serviceman')
            .then((hasPermissions) => {if (hasPermissions) {
                this.isServiceman = true;
        }});
    }

    private async determineEditAccess() {
        this.canEdit = (this.appointment.assignedCompanyId === this.activeUserCompanyId && ((this.document.assignedTo && this.document.assignedTo.startsWith(this.complaintService.getUserType())) || await this.permissionsService.hasPermission('complaints-manage-manufacturer'))) && !closedAppointmentStatuses.some((status) => status.value === this.appointment.status);
    }

    async ngOnChanges(): Promise<void> {
        await this.determineEditAccess();
    }

    removeAppointment() {
        this.complaintService.deleteAppointment(this.appointment);
    }

    editAppointment() {
        this.complaintService.editAppointment(this.document, this.appointment, this.attachments, true, this.positionsWorkflowsGroups);
    }

    editProtocol() {
        this.complaintService.editProtocol(this.document, this.appointment, this.attachments, this.positionsWorkflowsGroups, true, false);
    }

    viewProtocol() {
        this.complaintService.editProtocol(this.document, this.appointment, this.attachments, this.positionsWorkflowsGroups, false, true);
    }

    getWorkerName(id: number): string {
        return this.personsService.getWorkerByUserId(id)?.person.full_formal_name ?? '';
    }

    getAttachments(type: DocumentAttachment['attachmentType']): DocumentAttachment[] {
        return this.attachments.filter((attachment) => attachment.attachmentType === type && attachment.appointmentId === this.appointment.uuid);
    }

    getAttachment(type: DocumentAttachment['attachmentType'], uuid: string) {
        return this.attachments.find((attachment) => attachment.attachmentType === type && attachment.uuid === uuid);
    }

    async checkAccess() {
        this.canEdit = this.appointment.assignedCompanyId === this.activeUserCompanyId && ((this.document.assignedTo && this.document.assignedTo.startsWith(this.complaintService.getUserType())) || await this.permissionsService.hasPermission('complaints-manage-manufacturer'));
    }
}
